import { z } from 'zod';
import {
  EXTERNAL_PAGE_ROUTES,
  type ExternalTarget,
  externalPageKeySchema,
} from '../consts/external-pages';

export const externalEntrySearchSchema = z.object({
  token: z.string().optional().catch(undefined),
  refreshToken: z.string().optional().catch(undefined),
  page: z.string().optional().catch(undefined),
});

const externalEntryParamsSchema = z.object({
  token: z.string().min(1),
  refreshToken: z.string().min(1),
  page: externalPageKeySchema,
});

export type ExternalEntryParams = {
  token: string;
  refreshToken: string;
  target: ExternalTarget;
};

export const parseExternalEntryParams = (
  search: z.infer<typeof externalEntrySearchSchema>,
): ExternalEntryParams | undefined => {
  const { data } = externalEntryParamsSchema.safeParse(search);

  if (!data) return undefined;

  return {
    token: data.token,
    refreshToken: data.refreshToken,
    target: EXTERNAL_PAGE_ROUTES[data.page],
  };
};
